<template>
  <q-linear-progress v-if="this.isFetching" indeterminate />
  <div class="grouping-modal">
    <div
      v-if="isRevitFloorGrouping"
      class="grouping-modal__revit-controls"
    >
      <CustomSelect
        label="Категория"
        :options="bimCategories"
        optionLabelKey="category_name"
        optionValueKey="category_code"
        :value="categoryCode"
        :loading="isLoadingCategories"
        placeholder="Выберите категорию"
        :clearable="false"
        @change="(value) => categoryCode = value"
        style="width: 320px;"
      />
      <q-checkbox
        v-model="clearOld"
        label="Очистить старые данные"
        dense
      />
    </div>
    <ResidentialApartmentsList
      :floorsPlan="this.floorsPlan"
      :mode="this.data.mode"
      :updateData="this.updateData"
      :params="this.data?.params"
      :addData="this.data?.data"
    />
    <CustomModalFooter
      v-if="!!this.floorsPlan?.length && this.data?.mode !== 'grouping'"
      :onSubmit="this.onSubmit"
      class="grouping-modal__footer"
      :disableSubmit="disableSubmit"
      :style="{
        height: '86px'
      }"
    />
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";
import ResidentialApartmentsList from "@/views/BuildingSettings/ResidentialApartmentsList.vue";
import { checkFlatFloor, duplicateFlatToFloors, duplicateFloorGroup, getEntranceApartments } from "@/views/BuildingSettings/services";
import CustomSelect from "@/components/form/CustomSelect";
import { getBimCategories } from "@/views/BimCategories/services";

export default {
  name: "residential-grouping",
  components: { CustomModalFooter, ResidentialApartmentsList, CustomSelect },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      isFetching: false,
      selected: {},
      floorsPlan: [],
      isLoadingCategories: false,
      bimCategories: [],
      categoryCode: null,
      clearOld: true,
    };
  },
  computed: {
    isRevitFloorGrouping() {
      return this.data?.mode === 'floor-grouping' && this.data?.floor_map_resource_code && this.data.floor_map_resource_code !== 'AUTOCAD'
    },
    disableSubmit() {
      if (!this.isRevitFloorGrouping) return false
      return !this.categoryCode
    }
  },
  methods: {
    async loadBimCategories() {
      this.isLoadingCategories = true
      const res = await getBimCategories()
      this.isLoadingCategories = false
      if (!res) return
      // ожидаем category_code из БД; если его нет, пользователю не дадим сохранить
      this.bimCategories = res || []
    },
    async getData() {
      this.isFetching = true;
      const res = await getEntranceApartments(this.data?.params)
      this.isFetching = false;
      if(!res) return
      this.floorsPlan = res?.data
    },
    async handleDuplicateFloorGroup() {
      const body = {
        floor_map_id_from: this.data?.params?.floor_map_id,
        floor_arr: this.floorsPlan.filter(floor => floor.floor_map_id !== this.data?.params?.floor_map_id && floor.is_selected).map(floor => Number(floor.floor)),
      }
      if (this.isRevitFloorGrouping) {
        body.category_code = this.categoryCode
        body.clear_old = this.clearOld
      }
      return await duplicateFloorGroup(body, {floor_map_id: this.data?.params?.floor_map_id, project_type_id: this.data?.params?.project_type_id})
    },
    async handleDuplicateFlatFloorGroup() {
      const floorArr = []
      this.floorsPlan.forEach(floor => {
        if (floor.is_selected) {
          floor.flat?.forEach(apartment => {
            if(checkFlatFloor(floor, apartment, this.data?.data, true))
              floorArr.push(Number(floor.floor))
          })
        }
      })
      const body = {
        floor_flat_id_from: this.data?.data?.floor_flat_id,
        floor_arr: floorArr,
      }
      return await duplicateFlatToFloors(body, {floor_map_id: this.data?.params?.floor_map_id, project_type_id: this.data?.params?.project_type_id})
    },
    async onSubmit() {
      this.loading = true;
      const res = this.data?.mode === 'flat-grouping' ? await this.handleDuplicateFlatFloorGroup() : await this.handleDuplicateFloorGroup()
      this.loading = false;
      if(!res) return
      this.closeModal()
      this.showSucceedSnackbar()
      this.updateSubmitData(res)
    },
    updateData(res) {
      if(this.data?.mode === 'grouping') {
        this.floorsPlan = res?.data
      } else
        this.floorsPlan = res
      if(this.data?.mode === 'grouping')
        this.data.onSubmit && this.data.onSubmit(res)
    },
    updateSubmitData(res) {
      this.data.onSubmit && this.data.onSubmit(res)
    },
  },
  mounted() {
    this.getData()
    if (this.isRevitFloorGrouping) {
      this.loadBimCategories()
    }
  },
  setup() {
    const {closeModal} = useAppStore()
    const {showSucceedSnackbar} = useCustomSnackbar()
    return {showSucceedSnackbar, closeModal}
  }
};
</script>

<style scoped lang="scss">
.grouping-modal {
  min-width: 300px;
  padding-top: 20px;
  padding: 20px 20px 0 20px;
}

.grouping-modal__revit-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px 20px;
}

@media (max-width: 991px) {
  .grouping-modal {
    min-width: 100%;
  }
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 10px;
}
.grouping-modal__footer {
  position: sticky;
  bottom: -16px;
  background: #fff;
  padding: 20px 0 20px 0;
  margin-right: -1px;
}
</style>
